import { createBrowserRouter } from 'react-router-dom';

// Authentication Pages
import ForgotPassword from '../pages/ForgotPassword/ForgotPassword';
import Login from '../pages/Login/Login';
import Register from '../pages/Register/Register';
import ResetPassword from '../pages/ResetPassword/ResetPassword';
import VerifyAccount from '../pages/VerifyAccount/VerifyAccount';

// Dashboard Pages
import Dashboard from '../pages/Dashboard/Dashboard';

// Protected Route Component
import ProtectedRoute from '../components/ProtectedRoute/ProtectedRoute';

export const router = createBrowserRouter([
  // Authentication routes - redirect to dashboard if already logged in
  {
    path: '/auth/register',
    element: (
      <ProtectedRoute requireAuth={false}>
        <Register />
      </ProtectedRoute>
    ),
  },
  {
    path: '/auth/login',
    element: (
      <ProtectedRoute requireAuth={false}>
        <Login />
      </ProtectedRoute>
    ),
  },
  {
    path: '/auth/verify-account',
    element: (
      <ProtectedRoute requireAuth={false}>
        <VerifyAccount />
      </ProtectedRoute>
    ),
  },
  {
    path: '/auth/forgot-password',
    element: (
      <ProtectedRoute requireAuth={false}>
        <ForgotPassword />
      </ProtectedRoute>
    ),
  },
  {
    path: '/auth/reset-password',
    element: (
      <ProtectedRoute requireAuth={false}>
        <ResetPassword />
      </ProtectedRoute>
    ),
  },
  // Dashboard route - require authentication
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute requireAuth={true}>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  // Default redirect - check auth status
  {
    path: '/',
    element: (
      <ProtectedRoute requireAuth={true}>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
  // Catch all route - redirect based on auth status
  {
    path: '*',
    element: (
      <ProtectedRoute requireAuth={true}>
        <Dashboard />
      </ProtectedRoute>
    ),
  },
]);
